<template>
  <div v-if="kind === KINDS.NARROW" class="section" style="margin-top: 0.75rem;">
    <div class="container">
      <header>
	<div class="columns">
	  <div class="column is-offset-one-fifth is-three-fifths">
	    <slot name="header"></slot>
	  </div>
	</div>
      </header>
      <main class="columns is-fullwidth">
	<div class="column is-offset-one-fifth is-three-fifths">
	  <slot></slot>
	</div>
      </main>
    </div>
  </div>
  <div v-else-if="kind === KINDS.SIDEBAR" class="section" style="margin-top: 0.75rem;">
    <div class="container">
      <header>
	<div class="columns is-fullwidth">
	  <div class="column is-offset-one-third is-two-thirds is-hidden-mobile">
	    <slot name="header"></slot>
	  </div>
	</div>
      </header>
      <main>
	<div class="columns is-fullwidth">
	  <div class="column is-one-third is-hidden-mobile">
	    <slot name="sidebar"></slot>
	</div>
	<div class="column">
	  <slot></slot>
	</div>
	</div>
      </main>
      <footer></footer>
    </div>
  </div>
</template>

<script>
 const KINDS = {
   NARROW: 'narrow',
   WIDE: 'wide',
   SIDEBAR: 'sidebar',
 }

 export default {
   props: {
     kind: {
       type: String,
       default: KINDS.NARROW
     }
   },
   created() {
     this.KINDS = KINDS
   }
 }
</script>
